var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_90651)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_90651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_90651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.3334L7.99967 17.3334C7.81912 17.5139 7.5969 17.6042 7.33301 17.6042C7.06912 17.6042 6.8469 17.5139 6.66634 17.3334C6.48579 17.1528 6.39551 16.9306 6.39551 16.6667C6.39551 16.4028 6.48579 16.1806 6.66634 16L10.6663 12L6.66634 8.00004C6.48579 7.81948 6.39551 7.59726 6.39551 7.33337C6.39551 7.06949 6.48579 6.84726 6.66634 6.66671C6.8469 6.48615 7.06912 6.39587 7.33301 6.39587C7.5969 6.39587 7.81912 6.48615 7.99967 6.66671L11.9997 10.6667L15.9997 6.66671C16.1802 6.48615 16.4025 6.39587 16.6663 6.39587C16.9302 6.39587 17.1525 6.48615 17.333 6.66671C17.5136 6.84726 17.6038 7.06949 17.6038 7.33337C17.6038 7.59726 17.5136 7.81948 17.333 8.00004L13.333 12L17.333 16C17.5136 16.1806 17.6038 16.4028 17.6038 16.6667C17.6038 16.9306 17.5136 17.1528 17.333 17.3334C17.1525 17.5139 16.9302 17.6042 16.6663 17.6042C16.4025 17.6042 16.1802 17.5139 15.9997 17.3334L11.9997 13.3334Z",
    fill: "#ADADAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_90651"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue);
export default __webpack_public_path__ + "static/media/close-blue.d5806a281bac8c5e7e88d690fdf77e02.svg";
export { ForwardRef as ReactComponent };